import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import InputContainer from '../InputContainer/index.js';
import useDebouncingTextChange from '../../hooks/useDebouncingTextChange.js';
import { genericMemo } from '../../utils/index.js';
import AutoSizeTextArea from '../AutoSizeTextArea/index.js';
import styles from './styles.css.js';

function TextArea(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    onChange,
    name,
    value,
    containerRef,
    elementRef,
    style,
    autoSize,
    autoComplete = 'off',
    ...textAreaProps
  } = props;
  const {
    value: immediateValue,
    onInputChange: handleInputChange,
    onInputBlur: handleInputBlur
  } = useDebouncingTextChange({
    name,
    value,
    onChange
  });
  return /*#__PURE__*/React.createElement(InputContainer, {
    actions: actions,
    actionsContainerClassName: actionsContainerClassName,
    className: _cs(styles.textArea, className),
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: _cs(styles.inputSection, inputSectionClassName),
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    containerRef: containerRef,
    input: autoSize ? /*#__PURE__*/React.createElement(AutoSizeTextArea, _extends({
      className: styles.rawTextArea,
      elementRef: elementRef,
      readOnly: readOnly,
      style: style,
      disabled: disabled,
      onChange: handleInputChange,
      onBlur: handleInputBlur,
      value: immediateValue ?? '',
      autoComplete: autoComplete
    }, textAreaProps)) : /*#__PURE__*/React.createElement("textarea", _extends({
      className: styles.rawTextArea,
      ref: elementRef,
      readOnly: readOnly,
      style: style,
      disabled: disabled,
      onChange: handleInputChange,
      onBlur: handleInputBlur,
      value: immediateValue ?? '',
      autoComplete: autoComplete
    }, textAreaProps))
  });
}

var index = genericMemo(TextArea);

export { index as default };
//# sourceMappingURL=index.js.map
